import AutoContractGeneration from '../../../general-settings/enums/autoContractGeneration.enum';
import { StatusType } from '../../order.types';

export const requiredSignatureStatusesByAutoGeneration: Record<
  AutoContractGeneration,
  StatusType[]
> = {
  [AutoContractGeneration.IN_REVISION_OR_ON_APPROVAL]: [StatusType.DRAFT],
  [AutoContractGeneration.ON_APPROVAL]: [StatusType.DRAFT, StatusType.IN_REVISION],
  [AutoContractGeneration.ON_APPROVED]: [StatusType.ON_APPROVAL],
};
